const CycleTimeDiagramPage = () => import('frontend/presentation/cycle-time-diagram/views/CycleTimeDiagramPage.vue')
import usePerimeterChangeConfirmationModal
  from 'frontend/presentation/cycle-time-diagram/views/perimeter-change-confirmation-modal/usePerimeterChangeConfirmationModal'
import { DASHBOARD_MODULE_TOKENS } from 'frontend/constants/settings'

const NavigationModule = () => import('frontend/presentation/navigation/navigation-module/views/NavigationModule.vue')
const { toggleModal } = usePerimeterChangeConfirmationModal()
import { VS } from 'frontend/constants/callers'

export default [
  {
    shownInMenu: false,
    path: 'cycle-time-diagram',
    name: DASHBOARD_MODULE_TOKENS.cycleTimeDiagram.name,
    components: {
      header: NavigationModule,
      default: CycleTimeDiagramPage,
    },
    props: {
      header: { caller: VS, showPerimeterFinder: true, onApplyCallback: toggleModal },
    },
  },
]
